import React, { useEffect } from "react";
import Servicebanner from "../../Services/Servicebanner";
import NumberInfo from "../../Home/NumberInfo";
import Divser from "../../About/Divser";
import Infiry from "../../About/Infiry";
import Callin from "../../About/Callin";
import Divider from "../../Divider";
import ServiceReview from "../../Services/ServiceReview";
import Doctorbox from "../../Home/Docterbox";
import { movetop } from "../../../fun";
import IMsercontect from "./IMsercontect";
import { Helmet } from "react-helmet-async";

function INser() {
  type elem = {
    oneBody?: JSX.Element;
    twoBody?: JSX.Element;
    threeBody?: JSX.Element;
  };
  const elemnt: elem = {
    oneBody: <IMsercontect />,
    twoBody: <Infiry />,
    threeBody: <Callin />,
  };

  useEffect(() => {
    movetop();
  }, []);
  return (
    <>
      <Helmet>
        <title>Best Internal Medicine Provider in Whitefield</title>
        <meta
          name="description"
          content="We are the best internal medicine provider in Whitefield. If you are looking for this, visit us today or call us now."
        />
        <meta
          name="keywords"
          content="Best Internal medicine provider in Whitefield, Best Internal medicine provider in Vijayanagar, healthcare services in Whitefield, healthcare services in Vijayanagar, Multispeciality Clinic in Vijayanagar"
        />

        {/* JSON-LD Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "MedicalBusiness",
            "@id":
              "https://www.elvhealthcare.com/bestinternalmedicineinwhitefield#organization",
            name: "ELV Health Care Polyclinics",
            url: "https://www.elvhealthcare.com/bestinternalmedicineinwhitefield",
            description:
              "ELV Health Care Polyclinics in Whitefield offers expert internal medicine services for comprehensive diagnosis, preventive care, chronic disease management, and treatment of complex medical conditions by experienced internal medicine specialists.",
            logo: "https://www.elvhealthcare.com/favicon.ico",
            telephone: "+91-9535264855",
            email: "elvhealthcare@gmail.com",
            address: {
              "@type": "PostalAddress",
              streetAddress: "MR ASTER, Ground Floor, Vijayanagar, Whitefield",
              addressLocality: "Bengaluru",
              addressRegion: "Karnataka",
              postalCode: "560066",
              addressCountry: "IN",
            },
            geo: {
              "@type": "GeoCoordinates",
              latitude: 12.9764418,
              longitude: 77.7583566,
            },
            hasMap: "https://maps.app.goo.gl/C1xXW4kQyTxR8Sug9",
            knowsAbout: [
              "General medical diagnosis",
              "Chronic disease management",
              "Preventive health screenings",
              "Infections and acute illness care",
              "Patient-centred health planning",
              "Routine examinations and assessments",
              "Co-ordination with specialist referrals",
            ],
            keywords: [
              "best internal medicine in Immadihalli",
              "best internal medicine in Whitefield",
              "best internal medicine in Bangalore",
              "best internal medicine in Kundalahalli",
              "best internal medicine in Pattandur Agrahara",
            ],
          })}
        </script>
      </Helmet>

      <h2 style={{ display: "none" }}>
        Internal medicine provider in Whitefield Let us be your partner on the
        journey to optimal health and a better quality of life. Contact us for
        the best Internal medicine provider in Whitefield.
      </h2>

      <Servicebanner name="Internal Medicine" banner={"../photo/dd11.jpg"} />
      <NumberInfo test="test-black" />
      <Doctorbox />
      <Divser elemnt={elemnt} />
      {/* <div className="pt-10 pb-4">
        <Divider />
      </div>
      <Doctorbox /> */}
      <div className="pt-10 pb-4">
        <Divider />
      </div>
      <ServiceReview />
    </>
  );
}

export default INser;
